import { FC, useState, useRef, Fragment } from 'react';
import Link from 'next/link';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { MENU_LINKS } from '@/helpers/variables';
import styles from './Menu.module.scss';

const Menu: FC = () => {
  const NEW_PAGE_NAME = 'Вебтуны';

  const currentUrl = useGetUrlPath();
  const isMainPage = currentUrl === '/';

  const [mobileMenu, setMobileMenu] = useState(false);

  const refLeftMenu = useRef<HTMLDivElement>(null);

  const mobileMenuHandler = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <div className={styles.b_left_menu} ref={refLeftMenu}>
      <div onClick={mobileMenuHandler} className={!!mobileMenu ? `${styles.mobile_icon} ${styles.act}` : `${styles.mobile_icon}`}></div>
      <div className={!!mobileMenu ? `${styles.mobile_wrap} ${styles.act}` : `${styles.mobile_wrap}`}>
        <nav>
          <ul>
            {MENU_LINKS.map((item, i) => (
              <Fragment key={`${item.link}-${i}`}>
                {isMainPage && item.name === MENU_LINKS[0].name ? (
                  <></>
                ) : (
                  <li className={item.name === NEW_PAGE_NAME ? `${styles.new}` : `${styles.single}`}>
                    <Link prefetch={false} href={item.link}>
                      {item.name}
                    </Link>
                  </li>
                )}
              </Fragment>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Menu;
